export const SET_COLLABORATOR = "SET_COLLABORATOR";

export const setCollaborator = (collaborator) => {
  return {
    type: SET_COLLABORATOR,
    payload: collaborator,
  };
};
